<template>
		<div id="configurator"> 
			<div id="canvas-container"></div>		
		</div>
		
		<transition name="slow-fade">
			<div class="loader" v-if="loading_percentage>0&&loading_percentage<100">
				<div class="message large-font align-center">
					<div>Loading</div>
				</div>
				
				<div class="loading">
					<div class="dot"></div>
					<div class="dot"></div>
					<div class="dot"></div>
				</div>
			</div>
		</transition>
</template>

<script>
	import { mapState, mapGetters, mapMutations } from 'vuex';
	import ref from 'vue';
	
	import * as THREE from 'three';
	import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
	import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js'

	import { DRACOLoader } from 'three/addons/loaders/DRACOLoader.js';
	import { KTX2Loader } from 'three/addons/loaders/KTX2Loader.js';
	import { MeshoptDecoder } from 'three/addons/libs/meshopt_decoder.module.js';

	import { GLTFExporter } from 'three/addons/exporters/GLTFExporter.js'
	//import { USDZExporter } from 'three/addons/exporters/USDZExporter.js';
	import { RGBELoader } from 'three/addons/loaders/RGBELoader.js';
	import { RoomEnvironment } from 'three/addons/environments/RoomEnvironment.js';
	import { EffectComposer } from 'three/addons/postprocessing/EffectComposer.js';
	import { RenderPass } from 'three/addons/postprocessing/RenderPass.js';
	import { ShaderPass } from 'three/addons/postprocessing/ShaderPass.js';
	import { OutputPass } from 'three/addons/postprocessing/OutputPass.js';
	import emitter from 'tiny-emitter/instance'
	import axios from 'axios';
	
	var scene, renderer, composer, camera, controls, loader, bike_object, opaque_texture, lucid_texture, camera_reset_timeout;
	var cameraStartingPosition = new THREE.Vector3(-75,55,65);
	var bike_object = null;
	
	export default {
		name: 'AR',
		data: function () { return {
			default_camera_position : new THREE.Vector3(-92,53,72),
			//default_camera_position : new THREE.Vector3(0,0,10),
			mobile_camera_position : new THREE.Vector3(-70,102,142),
			//mobile_camera_position : new THREE.Vector3(0,0,10),
			template_camera_position : new THREE.Vector3(-140,17,0),
			//template_camera_position : new THREE.Vector3(0,0,10),
			screenshot_camera_position : new THREE.Vector3(-75,55,65),
			//screenshot_camera_position : new THREE.Vector3(-170,0,-10),
			screenshot_camera_position : new THREE.Vector3(-67, 35, 160),
			//
			cameraStartingPosition : this.default_camera_position,

			rendered_accessories : {},
			selected_accessories : {},
			loaded_accessories : {},
			cubes : {},
			inner_cubes: {},
			parts_loaded:0,
			parts_toload:0,
			loading_percentage: 0,
			loading: true
		}},
		computed: {
			...mapState([
				'bikes', 
				'accessories', 
				'current_bike', 
				'accessories_data',
				'creation',
				'creationID'
			]),
			...mapGetters(['customizable_parts', 'non_customizable_parts', 'cube_parts']),
		},
		mounted(){
			if(typeof window.base_url == 'undefined'){
				window.base_url = 'http://localhost/parkpre';
			}
			
			//Load texture
			lucid_texture = new THREE.TextureLoader().load( require('../assets/lucido.png') );
			opaque_texture = new THREE.TextureLoader().load( require('../assets/opaco.png') );
			
			//Load dati

			axios.get( base_url+'/wp-json/qzr-api/creation-data?'+(this.creationID?'creation='+this.creationID:''))
				.then(response => {
					this.setData(JSON.parse(response.data));
					//console.log(JSON.parse(response.data));
					
					setTimeout(()=> {
						this.setupScene();
					}, 1);
				});
		
		},
		methods: {
			...mapMutations([
				'setData', 
				'setCurrentBike', 
				'selectBike', 
				'setSelectedPart',
				'setAccessoriesData'
			]),

			async setupScene(){
				//Scene
				scene = new THREE.Scene();
				scene.background = new THREE.Color( 0x5A5A5A );
				
				//Camera
				camera = new THREE.PerspectiveCamera( 45, window.innerWidth / window.innerHeight, 1, 100000 );
				camera.near = 3.00;
							
				//Renderer
				renderer = new THREE.WebGLRenderer( { antialias: true , preserveDrawingBuffer: true } );
				renderer.setPixelRatio( window.devicePixelRatio );
				renderer.setSize( window.innerWidth, window.innerHeight );
				renderer.domElement.id = 'canvas';
				document.getElementById('canvas-container').appendChild( renderer.domElement );
				
				//Composer
				composer = new EffectComposer( renderer );
				
				const renderPass = new RenderPass( scene, camera );
				composer.addPass( renderPass );
				
				
				//Controls
				controls = new OrbitControls( camera, renderer.domElement );
				controls.enableDamping = true;
				controls.dampingFactor = 0.05;
				controls.enablePan = false; 
				controls.enableZoom = true;
				controls.minPolarAngle = 0.75;
				controls.maxPolarAngle = 1.5;
				controls.minDistance = 50;
				controls.maxDistance = 300;
				
				controls.target.y+=20;
				
				const dracoLoader = new DRACOLoader();
				dracoLoader.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');

				loader = new GLTFLoader();
				loader.setDRACOLoader(dracoLoader);
				loader.setMeshoptDecoder(MeshoptDecoder);
				
				this.animate();
				
				//window.bike_slug = 'ALGRAVEL';//TODO = REMOVE ME

				if(this.creationID != null){
					let creation_bike = this.bikes.find((b) => {
						return this.creation.bike_id == b.ID;
					});
					this.selectBike(creation_bike.ID);
					this.loadBike(creation_bike);
				}
			},
			
			loadBike(bike){
				//console.log('bike-data', bike);
				
				//Setto lo store
				this.setCurrentBike(bike);
				this.setSelectedPart(null);
				this.setLoadingPercentage(0);
				for(var type in this.rendered_accessories){
					this.$refs.accessoriesSelector.disableAccessory(type);
					this.$refs.accessoriesSelector.accessory_model = '';
					this.$refs.accessoriesSelector.current_options = null;
				}
				this.cubes = {};
				this.inner_cubes = {};
				//Pulisco la scena
				scene.remove(bike_object);
				this.disposeHierarchy(bike_object, this.disposeNode);
			
				//Avvio il caricamento del file
				var url = window.base_url+'/wp-content/uploads/bikes/'+bike.file_name+'.glb';
				
				loader.load( url, function ( object ) {
					//console.log(object);
					object = object.scene.children[0];
					this.setLoadingPercentage(50);
					
					//Aggiungo la bici alla scena
					scene.visible = false;
					object.name = 'bike';
					bike_object = object;
					bike_object.scale.set(1,1,1);
					scene.add( object );
					window.bike = object;
					
					setTimeout(this.setupParts, 500);
				}.bind(this), function( xhr ) {
					//Handler del progresso del caricamento file
					var load_percentage = Math.round(xhr.loaded / this.current_bike.file_size * 100);
					//this.setLoadingPercentage(load_percentage);
				}.bind(this), function( xhr ) {
					//Handler degli errori del caricamento file
					console.error( xhr );
				}.bind(this));
			},
			updateModelViewerProgress(progress){
				const progressBar = document.querySelector('.progress-bar');
				const updatingBar = document.querySelector('.update-bar');
				if(progressBar){
					updatingBar.style.width = `${progress}%`;
					if (progress === 100) {
						progressBar.classList.add('hide');
						//event.target.removeEventListener('progress', onProgress);
					} else {
						progressBar.classList.remove('hide');
					}
				}
			},
			async setLoadingPercentage(percentage){
				this.loading_percentage = percentage;
				this.updateModelViewerProgress(percentage);
				//console.log('loaded percentage', percentage);
				if(percentage>99) {
					this.loading = false;
					
					let gltfModel = await this.exportGLTFModel();
					//console.log(gltfModel);
					let gltfModelUrl = await this.exportGLTFURL(gltfModel);

					const modelViewer = document.querySelector('model-viewer');
					if(modelViewer){
						// todo: use this
						modelViewer.setAttribute('src', gltfModelUrl);
					}

					let data = new FormData;
					data.append('action', 'save_creation_model');
					data.append('creation_id', this.creationID);
					
					const glbBlob = new Blob([gltfModel], { type: 'model/gltf-binary' });
					const glbFile = new File([glbBlob], 'model.glb', { type: 'model/gltf-binary' });
					
					data.append('glb', glbFile);
					
					if(typeof ajaxurl != 'undefined'){
						
						axios.post(ajaxurl, data, {
							headers: { 'Content-Type': 'multipart/form-data' }
						}).then( response => {
							/*const modelViewer = document.querySelector('model-viewer');
							modelViewer.setAttribute('src', 'https://custom.parkpre.it/wp-content/uploads/user-model/'+this.creationID+'.glb');*/
							//console.log('saved', response, response.data.success);	
						})
					}
				}
			},
		
			setupParts(){	
				//Colorazione parti
				this.customizable_parts.forEach(part => {
					//console.log(part, part.customizable)
					if(part.type && part.type=='logo'){
						var ref = bike_object.getObjectByName( part.id );
						if(ref) {
							ref.renderOrder = 2
						}
					}
					if( part.hasOwnProperty('id') ){
						var ref = bike_object.getObjectByName( part.id );
						
						if(typeof ref != 'undefined'){
							var color = new THREE.Color(part.color);
							
							if(this.creation != null){
								let creation_part = this.creation.parts.find( p => {
									return p.id == part.id;
								});
								color = new THREE.Color(creation_part.color);
							}
							if(part.lucid && part.lucid == 'false') ref.material.roughnessMap = opaque_texture;
							ref.material.color.set(color);
						}
					}
				});

				//Colorazione parti
				this.non_customizable_parts.forEach(part => {
					var ref = bike_object.getObjectByName( part.id );
					if(ref) {
						//console.log(part, ref)
						ref.renderOrder = 2
					}
				});
				
				
				//Setto visibilità e reference dei cubi
				
				this.cube_parts.forEach(part => {
					const ref = bike_object.getObjectByName( part.id );
					const group = this.replaceCubeWithGroup(ref);
					//const group = ref;
					
					if( part.hasOwnProperty('cube_type') ){
						part.cube_type.forEach( type => {
							if(this.cubes[type]){
								this.cubes[type].push(group);
							}else{
								this.cubes[type] = [group]
							}
						});
					}
				});
				
				//Accessori
				if(this.creation != null){
					this.loadAccessories();
				}
				
				//Fine caricamento
				scene.visible = true;

				setTimeout(() => {
					//this.setLoadingPercentage(0);
				}, 2000);
			},
			
			renderAccessory(accessory,animateCamera = true){
				if (this.rendered_accessories.hasOwnProperty(accessory.type)) {
					//Disabilito gli accessori precedenti
					for (var file_name in this.rendered_accessories[accessory.type]){
						this.rendered_accessories[accessory.type][file_name].forEach( (a) => {
							if(a.parent) a.parent.remove(a);
						});
					}
				} else {
					this.rendered_accessories[accessory.type] = {};
				}
			

				//Altrimenti lo carico
				var url = window.base_url+'/wp-content/uploads/accessories/'+accessory.file_name+'.glb';
				//this.setLoadingPercentage(0);
				loader.load( url,  function(object) {
					this.parts_loaded++;
					//console.log('loaded',this.parts_loaded);
					//console.log(object.scene);
					if(accessory.type!='Gruppo') {
						object = object.scene.children[0];
					} else {
						for(var index in object.scene.children){
							object.scene.children[index].scale.set(1,1,1);
							object.scene.children[index].position.set(0,0,0);
							object.scene.children[index].rotation.set(0,0,0);
						}
						object = object.scene;
					}
					object.scale.set(1,1,1);
					object.position.set(0,0,0);
					object.rotation.set(0,0,0);

					if (!this.loaded_accessories.hasOwnProperty(accessory.type)) this.loaded_accessories[accessory.type] = {};
					this.loaded_accessories[accessory.type][accessory.file_name] = object.clone();

					this.placeAccessory(accessory, animateCamera);
					
				}.bind(this), function( xhr ) {
					//Handler del progresso del caricamento file
					var load_percentage = Math.round(xhr.loaded*100/xhr.total);
					//this.setLoadingPercentage(load_percentage);
				}.bind(this));
				
			},
			replaceCubeWithGroup(ref){
				const group = new THREE.Group();

				// Copy transformation properties from the Mesh (cube) to the Group
				group.position.copy(ref.position);
				group.rotation.copy(ref.rotation);
				group.scale.copy(ref.scale);
				group.name = ref.name;

				// Add the new group to the scene (or replace the old cube)
				ref.parent.add(group);

				// Remove the old cube from the scene
				ref.parent.remove(ref);
				return group;
			},
			placeAccessory(accessory,animateCamera=true){
				let object = this.loaded_accessories[accessory.type][accessory.file_name].clone();
				if(object.children && object.children.length){
					for(var index in object.children){
						if(object.children[index].name.includes('CUBO')){
							this.replaceCubeWithGroup(object.children[index]);
							//.material.visible = false;
							this.inner_cubes[accessory.type] = object.children[index].name;
						}
					}
				}
				var accessories = [];
				let temporaryPosition = false;
				let targetPosition = false;
				let currentAccessory = false;

				if(accessory.type=='Gruppo'){
					let catena = false,
						corona = false,
						cassetta = false;
					if(object.children && object.children.length){
						for(var index in object.children){
							if(object.children[index].name.includes('CATEN')){
								catena = object.children[index];
							} else if(object.children[index].name.includes('CORON')){
								corona = object.children[index];
							} else if(object.children[index].name.includes('CASSETT')){
								cassetta = object.children[index];
							}
						}
					}
					if(catena){
						let a = catena.clone();
						this.cubes['Catena'][0].add(a);
						accessories.push(a);
					}
					if(corona){
						let a = corona.clone();
						this.cubes['Corona'][0].add(a);
						accessories.push(a);
					}
					if(cassetta){
						let a = cassetta.clone();
						this.cubes['Cassetta'][0].add(a);
						currentAccessory = a;
						accessories.push(a);
						targetPosition = a.getWorldPosition(new THREE.Vector3());
					}
				} else {
					var cubes = this.cubes[accessory.type];
					switch(accessory.type){
						case 'Curva':
							if(this.inner_cubes['Attacco'] && this.inner_cubes['Attacco'].length) {
								cubes = [];
								cubes.push(bike_object.getObjectByName(this.inner_cubes['Attacco']));
							}
						break;

						case 'Sella':
							if(this.inner_cubes['Reggisella'] && this.inner_cubes['Reggisella'].length) {
								cubes = [];
								cubes.push(bike_object.getObjectByName(this.inner_cubes['Reggisella']));
							}
						break;
					}

					cubes.forEach( (cube,index) => {
						let a = object.clone();
						cube.add(a);
						//const boundingBox = new THREE.Box3().setFromObject(a);
						//scene.add(boundingBox);
						//let center = boundingBox.getCenter(new THREE.Vector3());
						currentAccessory = a;
						accessories.push(a);
						let cubePosition = a.getWorldPosition(new THREE.Vector3());
						if(!targetPosition || targetPosition.x < cubePosition.x) {
							targetPosition = cubePosition;
						}
					});
				}
				this.rendered_accessories[accessory.type][accessory.file_name] = accessories;

				switch(accessory.type){
					case 'Attacco':
						if(this.accessories_data['Curva'] && this.accessories_data['Curva'].id){
							let inner_accessory = this.accessories.find( a => a.ID == this.accessories_data['Curva'].id );
							this.disableAccessory('Curva')
							if(inner_accessory) this.placeAccessory(inner_accessory,false);
						}
					break;
					case 'Reggisella':
						if(this.accessories_data['Sella'] && this.accessories_data['Sella'].id){
							let inner_accessory = this.accessories.find( a => a.ID == this.accessories_data['Sella'].id );
							this.disableAccessory('Sella')
							if(inner_accessory) this.placeAccessory(inner_accessory,false);
						}
					break;
				}
				setTimeout(() => {
					this.setLoadingPercentage(50 + (this.parts_loaded/this.parts_toload)*50);
				}, 100);
			},

			disableAccessory(type){
				if(this.rendered_accessories.hasOwnProperty(type)){
					//Disabilito gli accessori precedenti
					for( var file_name in this.rendered_accessories[type] ){
						this.rendered_accessories[type][file_name].forEach( (a) => {
							if(a.parent) a.parent.remove(a);
						});
					}
					switch(type){
						case 'Attacco':
							this.inner_cubes['Attacco'] = [];
							if(this.accessories_data['Curva'] && this.accessories_data['Curva'].id){
								let inner_accessory = this.accessories.find( a => a.ID == this.accessories_data['Curva'].id );
								if(inner_accessory) this.placeAccessory(inner_accessory,false);
							}
						break;
						case 'Reggisella':
							this.inner_cubes['Reggisella'] = [];
							if(this.accessories_data['Sella'] && this.accessories_data['Sella'].id){
								let inner_accessory = this.accessories.find( a => a.ID == this.accessories_data['Sella'].id );
								if(inner_accessory) this.placeAccessory(inner_accessory,false);
							}
						break;
					}
				}
			},
			
			loadAccessories(){
				let creation_accessories = JSON.parse(this.creation.accessories);
				this.parts_toload = Object.keys(creation_accessories).length;
				let i = 0;
				this.setAccessoriesData(creation_accessories);
				console.log(creation_accessories);
				for(var type in creation_accessories){
					if(creation_accessories[type].id !='none'){
						var accessory = this.accessories.find( a => a.ID == creation_accessories[type].id );
						if(accessory) setTimeout(this.renderAccessory,100*i,accessory,false);
						i++;
					} else {
						this.parts_toload--;
					}
				}
				if(this.parts_toload == 0){
					setTimeout(() => {
						this.setLoadingPercentage(100);
					}, 200);
				}
			},

			animate(){
				requestAnimationFrame( this.animate );
				composer.render();
				controls.update();
			},
			
			//Rimuovo definitivamente un oggetto ricorsivamente
			disposeHierarchy(node, callback){
				if(node && node != null){
					for (var i = node.children.length - 1; i >= 0; i--){
						var child = node.children[i];
						this.disposeHierarchy(child, callback);
						callback(child);
					}
				}
			},
			//Libero un nodo
			disposeNode(node){
				if (node instanceof THREE.Mesh){
					if (node.geometry){
						node.geometry.dispose();
					}

					if (node.material){
						this.disposeMaterial(node.material);
					}
				}
			},
			//Libero un materiale
			disposeMaterial(material){
				if(Array.isArray(material)){
					material.forEach(function(m){
						this.disposeMaterial(m);
					}.bind(this));
				}else{
					if (material.map) material.map.dispose();
					if (material.lightMap) material.lightMap.dispose();
					if (material.bumpMap) material.bumpMap.dispose();
					if (material.normalMap) material.normalMap.dispose();
					if (material.specularMap) material.specularMap.dispose();
					if (material.envMap) material.envMap.dispose();

					material.dispose();
				}
			},
			updateModelRecursive(object) {
			    // Ensure the object's matrix is up-to-date
			    object.updateMatrix();

			    // If the object has geometry, apply the transformation matrix to its geometry
			    if (object.geometry) {
			        object.geometry.applyMatrix4(object.matrix);

			        // Optionally reset the object's transformation properties
			        object.position.set(0, 0, 0);
			        object.rotation.set(0, 0, 0);
			        object.scale.set(1, 1, 1);

			        // Ensure matrix transformations are applied to the object
			        object.updateMatrixWorld(true);
			    }

			    // Recursively apply the same process to the children
			    object.children.forEach(child => {
			        this.updateModelRecursive(child);
			    });
			},

			async exportGLTFModel(){
				return new Promise((resolve, reject) => {
					const exporter = new GLTFExporter();
					let export_scene = new THREE.Scene();
					let bike_clone = bike_object.clone();
					bike_clone.scale.set(0.01,0.01,0.01);
					this.updateModelRecursive(bike_clone);
					export_scene.add(bike_clone);

					exporter.parse(export_scene, (gltf) => {
						resolve(gltf);  // Resolves when parsing is done
					}, (error) => {
						reject(error);  // Rejects in case of error
					}, {binary: true, dracoOptions: {compressionLevel: 10}});
				});
			},

			async exportGLTFURL(gltf){
				return new Promise((resolve, reject) => {
					const blob = new Blob([gltf], { type: "model/gltf-binary" });
					const reader = new FileReader();
					reader.readAsDataURL(blob);
					reader.onloadend = () => resolve(reader.result);
					reader.onerror = (event) => {alert(event)};
				})
			},

			async createGLTFLoader( manager ) {

				const dracoLoader = new DRACOLoader();
				dracoLoader.setDecoderPath( '../examples/jsm/libs/draco/gltf/' );

				const ktx2Loader = new KTX2Loader( manager );
				ktx2Loader.setTranscoderPath( '../examples/jsm/libs/basis/' );

				editor.signals.rendererDetectKTX2Support.dispatch( ktx2Loader );

				const loader = new GLTFLoader( manager );
				loader.setDRACOLoader( dracoLoader );
				loader.setKTX2Loader( ktx2Loader );
				loader.setMeshoptDecoder( MeshoptDecoder );

				return loader;
			}
		}
	}
	

	/* UTILITIES */

</script>